import { render, staticRenderFns } from "./Formulas.vue?vue&type=template&id=c48ad366&scoped=true"
import script from "./Formulas.vue?vue&type=script&lang=js"
export * from "./Formulas.vue?vue&type=script&lang=js"
import style0 from "./Formulas.vue?vue&type=style&index=0&id=c48ad366&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c48ad366",
  null
  
)

export default component.exports